import React from 'react'
import styled from 'styled-components'

export type ListItemProps = {
  readonly label?: string
  readonly value?: string
}

export type TableListProps = {
  items: ListItemProps[]
}

const Label = styled.div`
  font-weight: bold;
  margin-right: 30px;
`
const Value = styled.div``

const ListItem = styled<React.FC<ListItemProps>>(({ label, value, ...props }) => {
  return (
    <div {...props}>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </div>
  )
})`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
  font-size: 14px;
  border-bottom: 1px solid #e5e5e5;
`

const TableList = styled<React.FC<TableListProps>>(({ items, ...props }) => {
  return (
    <div {...props}>
      {items.map((item, i) => (
        <ListItem key={i} label={item.label} value={item.value} />
      ))}
    </div>
  )
})`
  margin-bottom: 30px;
`

export default TableList
